/* eslint-disable */
// tslint:disable
/**
 * Контракты сервиса Учи.Ответы
 * Контракты сервиса Учи.Ответы
 *
 * OpenAPI spec version: 0.0.3-rc.7
 * Contact: team@uchi.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator+.
 * https://github.com/karlvr/openapi-generator-plus
 * Do not edit the class manually.
 */

export namespace Api {
  export interface GetMarusiaData200Response {
    /**
     * @description <p>Данные с ответом на вопрос от Маруси</p>
     * @type {Api.GetMarusiaData200Response.MarusiaAnswer | null}
     * @memberof GetMarusiaData200Response
     */
    marusia_answer?: Api.GetMarusiaData200Response.MarusiaAnswer | null;
  }

  /**
   * @export
   * @namespace GetMarusiaData200Response
   */
  export namespace GetMarusiaData200Response {
    /**
     * <p>Данные с ответом на вопрос от Маруси</p>
     */
    export interface MarusiaAnswer {
      /**
       * @description <p>Текст ответа на вопрос</p>
       * @type {string}
       * @memberof MarusiaAnswer
       */
      text: string;
      /**
       * @description <p>Лайкал ли юзер этот ответ от Маруси</p>
       * @type {boolean}
       * @memberof MarusiaAnswer
       */
      already_voted: boolean;
      /**
       * @description <p>Жаловался ли юзер на этот ответ от Маруси</p>
       * @type {boolean}
       * @memberof MarusiaAnswer
       */
      already_complained: boolean;
    }
  }

  export interface GetQuestion200Response {
    /**
     * @description <p>Данные вопроса</p>
     * @type {Api.GetQuestion200Response.Question}
     * @memberof GetQuestion200Response
     */
    question: Api.GetQuestion200Response.Question;
    /**
     * @description <p>Данные ответов на вопрос</p>
     * @type {Api.GetQuestion200Response.Answer[]}
     * @memberof GetQuestion200Response
     */
    answers: Api.GetQuestion200Response.Answer[];
    /**
     * @description <p>Микроразметка для вопроса</p>
     * @type {string}
     * @memberof GetQuestion200Response
     */
    question_micro_data: string;
    /**
     * @description <p>Информация с рекомендательным блоком</p>
     * @type {({ [name: string]: Api.GetQuestion200Response.RecommendedCourseDatum }) | null}
     * @memberof GetQuestion200Response
     */
    recommended_course_data: {
      [name: string]: Api.GetQuestion200Response.RecommendedCourseDatum;
    } | null;
    /**
     * @description <p>Данные для блока подготовки к уроку</p>
     * @type {Api.GetQuestion200Response.CourseLinksDatum[]}
     * @memberof GetQuestion200Response
     */
    course_links_data: Api.GetQuestion200Response.CourseLinksDatum[];
  }

  /**
   * @export
   * @namespace GetQuestion200Response
   */
  export namespace GetQuestion200Response {
    /**
     * <p>Данные вопроса</p>
     */
    export interface Question {
      /**
       * @type {number}
       * @memberof Question
       */
      id: number;
      page_description: string;
      page_title: string;
      body: string;
      slug: string;
      /**
       * @type {number}
       * @memberof Question
       */
      grade: number;
      author_avatar: string;
      /**
       * @type {number}
       * @memberof Question
       */
      published_answers_count: number;
      updated_at: string;
      created_at: string;
      question_state: Api.OtvetyApiQuestionsSlugGet200QuestionQuestionState;
      user_is_author: boolean;
      author_name: string;
      category: Api.GetQuestion200Response.Question.Category;
    }

    /**
     * @export
     * @namespace Question
     */
    export namespace Question {
      export interface Category {
        slug: string;
        title: string;
      }
    }

    export interface Answer {
      /**
       * @type {number}
       * @memberof Answer
       */
      id: number;
      body: string;
      answer_state: Api.OtvetyApiQuestionsSlugGet200QuestionQuestionState;
      updated_at: string;
      created_at: string;
      user_is_author: boolean;
      autor_name: string;
      autor_avatar: string;
      /**
       * @type {number}
       * @memberof Answer
       */
      likes_count: number;
      already_voted: boolean;
    }

    export interface RecommendedCourseDatum {
      text?: string;
      link?: string;
    }

    export interface CourseLinksDatum {
      title?: string;
      link?: string;
    }
  }

  export interface GetQuestion404Response {
    /**
     * @description <p>Сообщение об ошибке</p>
     * @type {string}
     * @memberof GetQuestion404Response
     */
    error?: string;
  }

  export enum OtvetyApiQuestionsSlugGet200QuestionQuestionState {
    Confirmed = 'confirmed',
    Declined = 'declined',
    Moderating = 'moderating',
  }

  export interface PostMarusiaComplain200Response {
    success: boolean;
  }

  export interface PostMarusiaVote200Response {
    success: boolean;
  }
}
